@if (languageService.isInitialized()) {
  <ion-app>
    <a href="#main-content" class="skip-link">{{ 'skipToMainContent' | transloco }}</a>
    <ion-router-outlet></ion-router-outlet>
    <div aria-live="polite" aria-atomic="true" class="sr-only">
      {{ screenReaderService.currentAnnouncement() | transloco }}
    </div>
  </ion-app>
} @else {
  <div class="app-loading-screen">
    <div class="spinner"></div>
    <p class="loading-text">Loading…</p>
  </div>
}
